import { FC } from "react";

export const HeaderMore: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="3.16667" cy="7.83366" r="1.16667" fill="#4A5368" />
    <circle cx="7.83268" cy="7.83366" r="1.16667" fill="#4A5368" />
    <ellipse
      cx="12.5007"
      cy="7.83366"
      rx="1.16667"
      ry="1.16667"
      fill="#4A5368"
    />
  </svg>
);
